import { load } from "scrivito"
import { BuildingReferenceObj } from "scrivito/Objs/BuildingReference/BuildingReferenceObjClass"
import { ProductObjClass } from "scrivito/Objs/Product/ProductObjClass"
import { ProductBaseVariantObjClass } from "scrivito/Objs/ProductBaseVariant/ProductBaseVariantObjClass"

export async function fetchBuildingReferenceVariantKeys(
  buildingReference: BuildingReferenceObj
) {
  const children = await load(() => buildingReference.children())
  const products = await Promise.all(
    children.map(child => load(() => child.get("product")))
  )
  const resolvedProducts = products.filter(
    product =>
      product instanceof ProductObjClass ||
      product instanceof ProductBaseVariantObjClass
  )

  return resolvedProducts.map(product => product.get("variantKey")?.toString())
}
